var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaptikConversationStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#464646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25997 7.48828V9.89059H4.28125V7.48828H5.25997ZM13.0897 7.48828V9.89059H12.111V7.48828H13.0897Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.285 6.91628V12.0641C12.285 12.6327 11.8241 13.0936 11.2555 13.0936H6.10769C5.53907 13.0936 5.07812 12.6327 5.07812 12.0641V6.91628C5.07812 6.34767 5.53907 5.88672 6.10769 5.88672H11.2555C11.8241 5.88672 12.285 6.34767 12.285 6.91628Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08788 8.78906C7.03287 8.78906 6.98827 8.74446 6.98827 8.68945C6.98827 8.63443 7.03287 8.58983 7.08788 8.58983C7.1429 8.58983 7.1875 8.63443 7.1875 8.68945C7.1875 8.74446 7.1429 8.78906 7.08788 8.78906Z",
    fill: "#464646",
    stroke: "#464646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.291 8.78906C10.236 8.78906 10.1914 8.74446 10.1914 8.68945C10.1914 8.63443 10.236 8.58983 10.291 8.58983C10.346 8.58983 10.3906 8.63443 10.3906 8.68945C10.3906 8.74446 10.346 8.78906 10.291 8.78906Z",
    fill: "#464646",
    stroke: "#464646"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08594 4.28516V5.88669",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 10.6914V11.4922H7.48438V10.6914",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaptikConversationStudio);
export default __webpack_public_path__ + "static/media/haptik-conversation-studio.2215db31.svg";
export { ForwardRef as ReactComponent };